import { render, staticRenderFns } from "./CarPricing.vue?vue&type=template&id=0f01b5fa"
import script from "./CarPricing.vue?vue&type=script&lang=js"
export * from "./CarPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FollowSocial: require('D:/private/personal-finance/src/components/Common/FollowSocial.vue').default,ShareSocial: require('D:/private/personal-finance/src/components/Common/ShareSocial.vue').default})
